
import EncryptedStorage from "react-native-encrypted-storage";

class CipherServiceClass {
  async set(key: string, value: string): Promise<void> {
    await EncryptedStorage.setItem(key, value);
  }

  async get(key: string): Promise<string> {
    const value = await EncryptedStorage.getItem(key);
    return value ?? "";
  }

  async remove(key: string): Promise<void> {
    await EncryptedStorage.removeItem(key);
  }

  async clear(): Promise<void> {
    await EncryptedStorage.clear();
  }
}

export const CipherService = new CipherServiceClass();
